import type React from 'react';

import { Grid } from '@change/ds-layout';

import { ChangeIcon } from '../shared/components/ChangeIcon';
import { DismissButton } from '../shared/components/DismissButton';
import { useBanner } from '../shared/hooks/useBanner';

import { Content } from './components/Content';

const BANNER_GRADIENT =
	'linear-gradient(74deg, rgb(254, 242, 242) 0%, rgb(255, 250, 237) 29%, rgb(255, 255, 235) 100%)';

type Props = {
	sourceLocation: string;
	setBannerClosed: () => void;
	bottomOffsetPx?: number;
};

export const IOSBanner: React.FC<Props> = ({ sourceLocation, setBannerClosed, bottomOffsetPx }) => {
	const {
		actions: { onClickClose, onClickDownload },
	} = useBanner({ sourceLocation, setBannerClosed });

	return (
		<div
			id="app-download-bottom-banner-v2"
			className="fixed bottom-0 left-0 z-30 block w-full border border-solid border-[#e5e5e5] py-4 shadow-[0px_10px_20px_0px_rgba(24,25,31,0.1)] md:hidden"
			style={{ backgroundImage: BANNER_GRADIENT, bottom: bottomOffsetPx ? `${bottomOffsetPx}px` : undefined }}
			data-testid="app-download-bottom-banner-v2"
			role="alert"
		>
			<DismissButton className="fixed top-auto right-[6px] -mt-2" onClick={onClickClose} />
			<Grid>
				<div className="col-span-4 mr-8 grid grid-cols-[auto_1fr] items-start gap-4">
					<ChangeIcon />
					<Content onClickDownload={onClickDownload} />
				</div>
			</Grid>
		</div>
	);
};
